import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import React from "react";
import PropTypes from "prop-types";
import { ScreenReaderOnly } from "@xo-union/ui-accessibility";
import { singular, plural, humanTermType } from "../humanTerms.js";
import { InclusiveRange } from "../Range/index.js";
const ScreenReaderDescription = _ref => {
  let {
    id,
    terms,
    visibleSlidesIndexRange,
    totalSlidesCount,
    containerRef
  } = _ref;
  const humanReadableRange = _mapInstanceProperty(visibleSlidesIndexRange).call(visibleSlidesIndexRange, num => num + 1);
  const {
    min,
    max
  } = humanReadableRange;
  const announcementTimeout = React.useRef();
  const [shouldAnnounceChanges, setShouldAnnounceChanges] = React.useState(false);

  /**
   * Avoid announcing state of carousels on page load and resize, only do it on change
   * when focused on an element in the carousel
   */
  React.useEffect(() => {
    if (containerRef.current.contains(document.activeElement)) {
      setShouldAnnounceChanges(true);
    }
    clearTimeout(announcementTimeout.current);
    announcementTimeout.current = _setTimeout(() => {
      setShouldAnnounceChanges(false);
    }, 2000);
    return () => {
      clearTimeout(announcementTimeout.current);
    };
  }, [min, max, containerRef]);
  const style = shouldAnnounceChanges ? undefined : {
    display: 'none'
  };
  const countPhrase = humanReadableRange.length === 1 ? `${singular(terms.slides)} number ${min}` : `${plural(terms.slides)} ${min} to ${max}`;
  return /*#__PURE__*/React.createElement(ScreenReaderOnly, {
    "aria-live": "assertive",
    "aria-atomic": "true",
    style: style,
    id: id
  }, `Showing ${countPhrase} out of ${totalSlidesCount}`);
};
process.env.NODE_ENV !== "production" ? ScreenReaderDescription.propTypes = {
  id: PropTypes.string,
  terms: humanTermType(['slides']),
  visibleSlidesIndexRange: PropTypes.instanceOf(InclusiveRange),
  totalSlidesCount: PropTypes.number,
  containerRef: PropTypes.shape({
    current: PropTypes.shape({
      contains: PropTypes.func
    })
  })
} : void 0;
export default ScreenReaderDescription;